export default {
  getCurrentService (state) {
    return state.currentService
  }
}
